export default "__VITE_ASSET__HrEhi6Nv__"